export const headerHeight = 64
export const headerHeightTablet = 105
export const headerHeightFull = 84
export const miniBarHeight = 31
export const subNavigationHeight = 133
